module.exports = __webpack_public_path__ + "img/SH2D_300008.b8cc0949.png";